import { createFileRoute } from "@tanstack/react-router";
import { RewardsPage } from "@/modules/rewards/presentation/pages/RewardsPage";

export const Route = createFileRoute("/_authenticated/rewards")({
  component: RewardsPage,
});
